<script setup>
const props = defineProps({
  event: {
    type: Object,
    required: true,
  },
})

const { t } = useI18n()

const hasInstructors = computed(
  () => props.event?.instructors && props.event?.instructors?.length > 0,
)
</script>

<template>
  <div
    class="overview__container flex flex-col flex-gap-y-2 bg-surface-100 p-4 text-sm"
  >
    <p class="text-text-600 fw-500">
      {{ t('Instructor') }}:
    </p>
    <div
      v-if="hasInstructors"
      class="header flex flex-col flex-gap-2"
    >
      <div
        v-for="instructor in props.event?.instructors"
        :key="instructor"
        class="flex flex-wrap items-center flex-gap-x-2"
      >
        <DSAvatar
          :image-url="instructor.picture_url"
          :name="instructor.name"
          size="xs"
        />
        <p class="text-text-500">
          {{ instructor.name }}
        </p>
      </div>
    </div>
    <p
      v-else
      class="content text-text-500"
    >
      {{ t("This event doesn't have an associated instructor") }}
    </p>
    <p class="mt-2 text-text-600 fw-500">
      {{ t('Event Details') }}:
    </p>
    <span
      v-sanitize="props.event?.description"
      class="content text-text-500"
    />
  </div>
</template>

<i18n>
{
  "en-us": {
    "Instructor": "Instructor",
    "Event Details": "Event Details",
    "This event doesn't have an associated instructor": "This event doesn't have an associated instructor"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Instructor": "Trainer:in",
  "Event Details": "Details zur Veranstaltung",
  "This event doesn't have an associated instructor": "Zu dieser Veranstaltung gibt es keinen Trainer:in"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Instructor": "Instructeur",
  "Event Details": "Détails de l'événement",
  "This event doesn't have an associated instructor": "Cet événement n'a pas d'instructeur associé"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Event Details": "Información sobre el evento",
  "This event doesn't have an associated instructor": "Este evento no tiene ningún instructor asociado"
}
</i18n>
